import { ListItemIcon, RedListItemText } from '@/components/Dropdown/MenuItems/components';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import Remove from '@/images/Remove.svg';
import { useAnalytics } from '@/services/analytics';
import theme from '@/theme';
import { ICampaign } from '@d-id/types';
import MenuItem from '@mui/material/MenuItem';

interface Props {
    campaign: ICampaign;
    closeMenu: () => void;
    onDelete: () => void;
}

export const DeleteMenuItem = ({ campaign, closeMenu, onDelete }: Props) => {
    const mixpanel = useAnalytics();

    return (
        <MenuItem
            onClick={async () => {
                mixpanel?.track('campaigns-delete', { event: 'click', campaign, from: 'menu' });

                closeMenu();
                onDelete();
            }}>
            <ListItemIcon>
                <MaskedIcon src={Remove} size="24px" color={theme.colors.error.main} />
            </ListItemIcon>
            <RedListItemText>Delete</RedListItemText>
        </MenuItem>
    );
};
